import styled from 'styled-components';

export const ServicesList = styled.div`
  width: 100%;
  padding: 0.25rem 0;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
`;

export const ServiceRow = styled.div`
  padding: 0.85rem 1.25rem;

  & + & {
    border-top: 1px solid var(--border);
  }
`;
